import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { EncomendaHistorico } from 'src/app/api';
import { of, throwError } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { BaseDialog } from '../../base-dialog';
import { BlockPackageConfirmationDialogComponent } from '../block-package-confirmation-dialog/block-package-confirmation-dialog.component';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'mandae-block-package-dialog',
  templateUrl: './block-package-dialog.component.html',
  styleUrls: ['../dialog-shared.scss', './block-package-dialog.component.scss']
})
export class BlockPackageDialogComponent extends BaseDialog<BlockPackageDialogComponent> {

  public customReason: string;
  public reason: string;
  public requester: string;

  constructor(
    dialogRef: MatDialogRef<BlockPackageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: EncomendaHistorico,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private orderService: OrderService,
  ) {
    super(dialogRef);
  }

  public submitForm() {
    this.dialog.open(BlockPackageConfirmationDialogComponent).afterClosed()
      .pipe(
        switchMap(result => {
          if (!result) {
            this.cancel();
            return of();
          }

          return this.orderService.bloquearEncomenda(this.data.id, {
            nomeSolicitante: this.requester,
            motivo: this.reason,
          }).pipe(
            tap(() => {
              this.snackBar.open(`Encomenda "${this.data.codigoRastreamento}" bloqueada com sucesso`, 'FECHAR', {
                duration: 2500
              });
              this.accept('blocked');
            }, () => {
              this.snackBar.open(`Ocorreu um erro ao bloquear a encomenda "${this.data.codigoRastreamento}"`, 'FECHAR', {
                duration: 2500
              });
            }),
          );
        }),
      )
      .subscribe();
  }

}
